module.exports = __webpack_public_path__ + "media/images/icons/twotone/home-d1567865e163e9309d7ac16d6755a15d.svg";